var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',{staticClass:"notice-wrap",class:_vm.type},[_c('veui-icon',{staticClass:"icon",attrs:{"name":"exclamation-circle-solid"}}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }